module.exports = __webpack_public_path__ + "c9cbbdc3762c340d5d37073a54971487.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-Heavy.woff2
// module id = 971
// module chunks = 0